import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {User} from '~/shared/types/types';

const initialState: User = {
  id: '',
  name: '',
  customer_id: '',
  created_at: '',
  created_by: '',
  assigned_to: '',
  comment: '',
  token: '',
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setID(state, action: PayloadAction<string>) {
      state.id = action.payload;
    },
    setName(state, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    setCustomerId(state, action: PayloadAction<string>) {
      state.customer_id = action.payload;
    },
    setCreatedAt(state, action: PayloadAction<string>) {
      state.created_at = action.payload;
    },
    setCreatedBy(state, action: PayloadAction<string>) {
      state.created_by = action.payload;
    },
    setAssignedTo(state, action: PayloadAction<string>) {
      state.assigned_to = action.payload;
    },
    setComment(state, action: PayloadAction<string>) {
      state.comment = action.payload;
    },
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
  },
});

export const {setID} = userSlice.actions;
export const {setName} = userSlice.actions;
export const {setCustomerId} = userSlice.actions;
export const {setCreatedAt} = userSlice.actions;
export const {setCreatedBy} = userSlice.actions;
export const {setAssignedTo} = userSlice.actions;
export const {setComment} = userSlice.actions;
export const {setToken} = userSlice.actions;

export default userSlice;

export const getToken = state => state.user.token;
